<template>
    <st-scrolly :dontUseSticky="false">
        <template v-slot:background="{slideIndex, progress}">
            <CanvasMap :scrollyParams="{slideIndex, progress}" :attributes="attributes"></CanvasMap>
        </template>

        <template v-slot:default>
            <div class="slide" v-for="(slide, i) in attributes.value.slides" :key="i">
                <div class="slide-content">
                    <p v-markdown="slide.deck"></p>
                </div>
            </div>
        </template>
    </st-scrolly>
</template>

<script>
// https://github.com/yongjun21/st-scrolly/blob/master/packages/%40st-graphics/scrolly/src/index.vue
import StScrolly from "@st-graphics/scrolly"
import "@st-graphics/scrolly/dist/bundle.css"
import CanvasMap from "./CanvasMap.vue"

export default {
    props: ["attributes"],
    components: {
        StScrolly,
        CanvasMap
    }
}
</script>

<style lang="scss">
    .component-canvasmap {
        .slide {
            padding-top: 70vh;
            padding-bottom: 30vh;
            &:first-child {
                padding-top: initial !important;
                padding-bottom: initial !important;
                .slide-content {
                    height: 100vh;
                    background-color: initial !important;
                    max-width: initial !important;
                    padding: initial !important;
                    margin: initial !important;
                    display: flex !important;
                    justify-content: center;
                    align-items: center;
                    p:only-child {
                        padding: initial !important;
                    }
                }
            }
            &:last-child {
                padding-bottom: 60vh;
            }

            .cover-text-flying {
                z-index: 1;
                align-self: center;
                padding: 0 32px;
                max-width: 700px;
                .cover-headline-container {
                    padding: 25px 0 42px;
                    @media (max-width: 768px) {
                        padding: 12px 0 35px;
                    }
                    .cover-headline {
                        font-family: $font-SelaneTwenty, Georgia, serif;
                        font-size: 50px;
                        line-height: 52px;
                        margin: 0;
                        @media (max-width: 768px) {
                            font-family: $font-SelaneForty;
                            font-size: 32px;
                            line-height: 35px;
                        }
                    }
                }
                .cover-deck {
                    color: #494949;
                    font-size: 23px;
                    line-height: 30px;
                    padding-bottom: 12px;
                    @media (max-width: 768px) {
                        font-size: 20px;
                        line-height: 28px;
                    }
                }
                .cover-byline {
                    font-family: $font-CuratorRegular, "Helvetica Neue", Helvetica, Arial, sans-serif;
                    color: #616161;
                    text-transform: uppercase;
                    font-size: 12px;
                    line-height: 14.4px;
                }
            }
        }
    }
</style>